"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeCms_en_us = void 0;
function backofficeCms_en_us() {
    return {
        "backoffice.cms.title": "CMS pages",
        "backoffice.cms.subtitle": "Create CMS pages which can be displayed in widgets, applications or external systems.",
        "backoffice.cms.pagetitle": "Page title",
        "backoffice.cms.editpage": "Edit page",
        "backoffice.cms.delete.page": "Delete page",
        "backoffice.cms.listempty": "Nothing to display! You did not create any pages yet...",
        "backoffice.cms.emptytitle": "No pages found...",
        "backoffice.cms.emptymessage": "Nothing to display! You did not create any pages yet. Why don't you start with creating your home page!",
        "backoffice.cms.pages.info": "Infos",
        "backoffice.cms.pages.content": "Content",
        "backoffice.cms.pages.availableinallcountries": "Available in all countries",
        "backoffice.cms.pages.draft.name": "Name",
        "backoffice.cms.pages.draft.title": "Title",
        "backoffice.cms.pages.draft.tags": "Tags",
        "backoffice.cms.pages.draft.tagsdescription": "Tags can be used to sort, filter or group your cms pages",
        "backoffice.cms.pages.draft.transform": "transform",
        "backoffice.cms.pages.draft.transformhint": "transform the title to a url conform name",
        "backoffice.cms.pages.draft.metadata.label": "Project related data",
        "backoffice.cms.pages.draft.metadata.description": "Here you can add project related data to your cms pages",
        "backoffice.cms.pages.table.name": "Name",
        "backoffice.cms.pages.table.createdat": "Created at",
        "backoffice.cms.pages.table.title": "Title",
        "backoffice.cms.pages.table.tags": "Tags",
        "backoffice.cms.pages.projectrelateddata.addkey": "Add Key",
        "backoffice.cms.pages.empty.title": "No locales defined",
        "backoffice.cms.pages.empty.message": "CMS pages are offered localized. In order to create a new CMS page you need to set up at least one locale.",
        "backoffice.cms.pages.empty.createnewlocale": "Create new locales",
        "backoffice.cms.tooltip.name": "String that will be shown in the url"
    };
}
exports.backofficeCms_en_us = backofficeCms_en_us;
